module.exports = '4.5.3';



// WEBPACK FOOTER //
// ./src/version.js